import { clamp01 } from './utils';

/** Kalibrierung der Pegel-Skala (dBFS-ähnlich aus RMS). */
export const LOUDNESS_DB = {
  /** Unterhalb: Stille / Noise-Gate */
  silenceDb: -78,
  /** „Mittellaut“ → normalisiert 0,5 */
  mediumDb: -60,
  /** Sehr laut → normalisiert 1 */
  loudDb: -24
} as const;

/** dB → 0…1; -60 dB ≈ 0,5 (mittellaut). */
export function loudnessNormalizedFromDb(levelDb: number): number {
  const { silenceDb, mediumDb, loudDb } = LOUDNESS_DB;
  if (levelDb <= silenceDb) return 0;
  if (levelDb >= loudDb) return 1;
  if (levelDb <= mediumDb) {
    return clamp01((0.5 * (levelDb - silenceDb)) / (mediumDb - silenceDb));
  }
  return clamp01(0.5 + (0.5 * (levelDb - mediumDb)) / (loudDb - mediumDb));
}
